module.exports = __webpack_public_path__ + "static/media/simpliroute.8b1a365c.png";